// MyRequestPage.js

import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  ImageBackground,
  ActivityIndicator,
  FlatList,
  Alert,
  TouchableOpacity,
  Platform,
} from "react-native";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import back7 from "./back9.png"; // Ensure this image is placed correctly in your project

const db = getFirestore();
const auth = getAuth();

const MyRequestPage = () => {
  const [myRequests, setMyRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      Alert.alert("Authentication Required", "Please log in to view your requests.");
      return;
    }

    const fetchMyRequests = async () => {
      try {
        const q = query(
          collection(db, "listings"),
          where("userID", "==", currentUser.uid),
          where("status", "in", ["Pending Approval", "Pending Payment"])
        );
        const querySnapshot = await getDocs(q);
        const requests = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMyRequests(requests);
      } catch (error) {
        console.error("Error fetching my requests:", error);
        Alert.alert("Error", "Failed to fetch your requests. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchMyRequests();
  }, [currentUser]);

  // Render individual request item
  const renderRequestItem = ({ item }) => (
    <View style={styles.requestCard}>
      <Text style={styles.requestText}>
        <Text style={styles.boldText}>Listing ID:</Text> {item.listingID}
      </Text>
      <Text style={styles.requestText}>
        <Text style={styles.boldText}>Car Name:</Text> {item.carName}
      </Text>
      <Text style={styles.requestText}>
        <Text style={styles.boldText}>Status:</Text> {item.status}
      </Text>
      <Text style={styles.requestText}>
        <Text style={styles.boldText}>Initial Investment:</Text> $
        {item.initialInvestment?.toLocaleString()}
      </Text>
      {/* Add more fields if necessary */}
    </View>
  );

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#007bff" />
      </View>
    );
  }

  if (!currentUser) {
    return (
      <View style={styles.centeredContainer}>
        <Text style={styles.infoText}>Please log in to view your requests.</Text>
      </View>
    );
  }

  return (
    <ImageBackground source={back7} style={styles.backgroundImage}>
      <View style={styles.overlay}>
        <View style={styles.contentContainer}>
          <Text style={styles.header}>My Current Requests</Text>
          {myRequests.length > 0 ? (
            <FlatList
              data={myRequests}
              keyExtractor={(item) => item.id}
              renderItem={renderRequestItem}
              contentContainerStyle={styles.listContainer}
            />
          ) : (
            <Text style={styles.infoText}>You do not have any pending requests at this time.</Text>
          )}
        </View>
      </View>
    </ImageBackground>
  );
};

export default MyRequestPage;

// ----------------
// StyleSheet
// ----------------
const styles = StyleSheet.create({
  backgroundImage: {
    flex: 1,
    resizeMode: "cover", // Ensure the image covers the screen
    justifyContent: "center",
  },
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent overlay for better readability
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  contentContainer: {
    maxWidth: 800, // Adjust as needed for responsiveness
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Slightly transparent white background
    borderRadius: 10,
    padding: 20,
  },
  header: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#007bff",
    textAlign: "center",
    marginBottom: 20,
  },
  listContainer: {
    paddingBottom: 20,
  },
  requestCard: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 15,
    marginBottom: 15,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 3, // For Android shadow
  },
  requestText: {
    fontSize: 16,
    color: "#333",
    marginBottom: 5,
  },
  boldText: {
    fontWeight: "bold",
    color: "#000",
  },
  infoText: {
    fontSize: 16,
    color: "#333",
    textAlign: "center",
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
  },
  centeredContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#f9f9f9",
  },
});
